import React from 'react';
import { Baby, Waves, Dumbbell, Wifi, Wrench, PawPrint } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { facilities, targetGroups } from '../data/mock';

const Facilities = () => {
  const facilityIcons = {
    'Pro děti': Baby,
    'Koupání': Waves,
    'Sport & Zábava': Dumbbell,
    'Technické zázemí': Wifi,
    'Ostatní': PawPrint
  };

  const colors = ['emerald', 'blue', 'amber', 'purple', 'rose'];

  return (
    <section id="facilities" className="py-20 bg-gradient-to-b from-white to-emerald-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Vybavení & Služby
          </h2>
          <div className="w-24 h-1 bg-emerald-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600">
            Kompletní vybavení pro vaše pohodlí a zábavu
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {facilities.map((facility, index) => {
            const Icon = facilityIcons[facility.category] || Wrench;
            const color = colors[index % colors.length];
            
            return (
              <Card
                key={index}
                className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-transparent hover:border-emerald-200"
              >
                <CardContent className="p-6">
                  <div className={`w-14 h-14 bg-${color}-100 rounded-full flex items-center justify-center mb-4 group-hover:bg-${color}-600 transition-colors`}>
                    <Icon className={`w-7 h-7 text-${color}-600 group-hover:text-white transition-colors`} />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">
                    {facility.category}
                  </h3>
                  <ul className="space-y-2">
                    {facility.items.map((item, idx) => (
                      <li key={idx} className="flex items-start space-x-2">
                        <span className="text-emerald-600 mt-1">•</span>
                        <span className="text-gray-700 text-sm">{item}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Facilities;
